// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamSectionGroup-module__font-s-10___awlbg {
  font-size: 10px !important;
}

.TeamSectionGroup-module__font-s-12___vtcaz {
  font-size: 12px !important;
}

.TeamSectionGroup-module__font-s-13___z5C5Q {
  font-size: 13px !important;
}

.TeamSectionGroup-module__font-s-14___v9G5s {
  font-size: 14px !important;
}

.TeamSectionGroup-module__font-s-15___gChI6 {
  font-size: 15px !important;
}

.TeamSectionGroup-module__font-s-16___MuDm9 {
  font-size: 16px !important;
}

.TeamSectionGroup-module__font-s-18___TmC7Z {
  font-size: 18px !important;
}

.TeamSectionGroup-module__font-s-20___uAAY4 {
  font-size: 20px !important;
}

.TeamSectionGroup-module__font-s-22___Fc0YL {
  font-size: 22px !important;
}

.TeamSectionGroup-module__font-s-28___zXMIQ {
  font-size: 28px !important;
}

.TeamSectionGroup-module__font-w-400___JeWYE {
  font-weight: 400 !important;
}

.TeamSectionGroup-module__font-w-500___HDCK8 {
  font-weight: 500 !important;
}

.TeamSectionGroup-module__font-w-600___Ue3lG {
  font-weight: 600 !important;
}

.TeamSectionGroup-module__font-w-700___Sm4wa {
  font-weight: 700 !important;
}

.TeamSectionGroup-module__p-5___Q8kpD {
  padding: 5px !important;
}

.TeamSectionGroup-module__p-12___chIHN {
  padding: 12px !important;
}

.TeamSectionGroup-module__p-16___pMOMi {
  padding: 16px !important;
}

.TeamSectionGroup-module__p-30___XC0Yv {
  padding: 30px !important;
}

.TeamSectionGroup-module__p-b-0___h3AFE {
  padding-bottom: 0 !important;
}

.TeamSectionGroup-module__p-b-5___p9rpc {
  padding-bottom: 5px !important;
}

.TeamSectionGroup-module__p-b-10___cgr4D {
  padding-bottom: 10px !important;
}

.TeamSectionGroup-module__p-b-12___IqbAX {
  padding-bottom: 12px !important;
}

.TeamSectionGroup-module__p-b-16___bJN8D {
  padding-bottom: 16px !important;
}

.TeamSectionGroup-module__p-b-18___rkplP {
  padding-bottom: 18px !important;
}

.TeamSectionGroup-module__p-b-20___zdUoF {
  padding-bottom: 20px !important;
}

.TeamSectionGroup-module__p-b-25___gg6bU {
  padding-bottom: 25px !important;
}

.TeamSectionGroup-module__p-b-30___txiLP {
  padding-bottom: 30px !important;
}

.TeamSectionGroup-module__p-b-50___pA2VL {
  padding-bottom: 50px !important;
}

.TeamSectionGroup-module__p-t-0___hvUyX {
  padding-top: 0 !important;
}

.TeamSectionGroup-module__p-t-12___abmJo {
  padding-top: 12px !important;
}

.TeamSectionGroup-module__p-t-16___ALPB2 {
  padding-top: 16px !important;
}

.TeamSectionGroup-module__p-t-18___Mm2aU {
  padding-top: 18px !important;
}

.TeamSectionGroup-module__p-t-20___TUV9R {
  padding-top: 20px !important;
}

.TeamSectionGroup-module__p-t-30___una2i {
  padding-top: 30px !important;
}

.TeamSectionGroup-module__p-t-40___p9lby {
  padding-top: 40px !important;
}

.TeamSectionGroup-module__p-t-50___CjKPM {
  padding-top: 50px !important;
}

.TeamSectionGroup-module__p-l-20___mXDLh {
  padding-left: 20px !important;
}

.TeamSectionGroup-module__p-l-30___KcOkb {
  padding-left: 30px !important;
}

.TeamSectionGroup-module__p-l-40___G2ULF {
  padding-left: 40px !important;
}

.TeamSectionGroup-module__p-r-16___qBm9e {
  padding-right: 16px !important;
}

.TeamSectionGroup-module__p-r-20___jx1fK {
  padding-right: 20px !important;
}

.TeamSectionGroup-module__p-r-30___sXIsn {
  padding-right: 30px !important;
}

.TeamSectionGroup-module__p-r-50___sZg6H {
  padding-right: 50px !important;
}

.TeamSectionGroup-module__p-r-60___RKSSF {
  padding-right: 60px !important;
}

.TeamSectionGroup-module__m-b-1___tIcLj {
  margin-bottom: 1px !important;
}

.TeamSectionGroup-module__m-b-2___rt5fs {
  margin-bottom: 2px !important;
}

.TeamSectionGroup-module__m-b-6___ZReZX {
  margin-bottom: 6px !important;
}

.TeamSectionGroup-module__m-b-8___DTSrk {
  margin-bottom: 8px !important;
}

.TeamSectionGroup-module__m-b-10___ytDTK {
  margin-bottom: 10px !important;
}

.TeamSectionGroup-module__m-b-14___Y52dN {
  margin-bottom: 14px !important;
}

.TeamSectionGroup-module__m-b-16___oIj69 {
  margin-bottom: 16px !important;
}

.TeamSectionGroup-module__m-b-20___kE3Zb {
  margin-bottom: 20px !important;
}

.TeamSectionGroup-module__m-b-22___W6eWg {
  margin-bottom: 22px !important;
}

.TeamSectionGroup-module__m-b-24___qYd1Z {
  margin-bottom: 24px !important;
}

.TeamSectionGroup-module__m-b-30___H7lQl {
  margin-bottom: 30px !important;
}

.TeamSectionGroup-module__m-b-32___feMwa {
  margin-bottom: 32px !important;
}

.TeamSectionGroup-module__m-b-40___b88GJ {
  margin-bottom: 40px !important;
}

.TeamSectionGroup-module__m-t-2___vJeAE {
  margin-top: 2px !important;
}

.TeamSectionGroup-module__m-t-3___Cvy1u {
  margin-top: 3px !important;
}

.TeamSectionGroup-module__m-t-4___AjWTY {
  margin-top: 4px !important;
}

.TeamSectionGroup-module__m-t-5___wpZXB {
  margin-top: 5px !important;
}

.TeamSectionGroup-module__m-t-8___jQiS6 {
  margin-top: 8px !important;
}

.TeamSectionGroup-module__m-t-10___DnFcS {
  margin-top: 10px !important;
}

.TeamSectionGroup-module__m-t-15___eF3TE {
  margin-top: 15px !important;
}

.TeamSectionGroup-module__m-t-16___IHlSq {
  margin-top: 16px !important;
}

.TeamSectionGroup-module__m-t-20___p0oS9 {
  margin-top: 20px !important;
}

.TeamSectionGroup-module__m-t-22___dJig9 {
  margin-top: 22px !important;
}

.TeamSectionGroup-module__m-t-30___noxxv {
  margin-top: 30px !important;
}

.TeamSectionGroup-module__m-t-32___ULgkS {
  margin-top: 32px !important;
}

.TeamSectionGroup-module__m-l-auto___vwONj {
  margin-left: auto !important;
}

.TeamSectionGroup-module__m-l-4___NGRmL {
  margin-left: 4px !important;
}

.TeamSectionGroup-module__m-l-5___HkmlT {
  margin-left: 5px !important;
}

.TeamSectionGroup-module__m-l-6___BwMoL {
  margin-left: 6px !important;
}

.TeamSectionGroup-module__m-l-8___iC6Yq {
  margin-left: 8px !important;
}

.TeamSectionGroup-module__m-l-10___mRx7J {
  margin-left: 10px !important;
}

.TeamSectionGroup-module__m-l-16___UMAxM {
  margin-left: 16px !important;
}

.TeamSectionGroup-module__m-l-20___voRBk {
  margin-left: 20px !important;
}

.TeamSectionGroup-module__m-l-24___upLxv {
  margin-left: 24px !important;
}

.TeamSectionGroup-module__m-l-30___h1n3e {
  margin-left: 30px !important;
}

.TeamSectionGroup-module__m-l-35____jxt3 {
  margin-left: 35px !important;
}

.TeamSectionGroup-module__m-l-40___DiLqg {
  margin-left: 40px !important;
}

.TeamSectionGroup-module__m-r-8___jPMnp {
  margin-right: 8px !important;
}

.TeamSectionGroup-module__m-r-10___Walm0 {
  margin-right: 10px !important;
}

.TeamSectionGroup-module__m-r-16___u8AzH {
  margin-right: 16px !important;
}

.TeamSectionGroup-module__m-r-20___vL6oW {
  margin-right: 20px !important;
}

.TeamSectionGroup-module__m-r-24___sM0gT {
  margin-right: 24px !important;
}

.TeamSectionGroup-module__m-r-30___nDc8b {
  margin-right: 30px !important;
}

.TeamSectionGroup-module__m-r-40___hZdz2 {
  margin-right: 40px !important;
}

.TeamSectionGroup-module__border-r-3___nq9ui {
  border-radius: 3px !important;
}

.TeamSectionGroup-module__border-r-4___EtqWT {
  border-radius: 4px !important;
}

.TeamSectionGroup-module__border-r-6____pAyi {
  border-radius: 6px !important;
}

.TeamSectionGroup-module__border-r-10___h75qZ {
  border-radius: 10px !important;
}

.TeamSectionGroup-module__border-r-12___Zg4Nt {
  border-radius: 12px !important;
}

.TeamSectionGroup-module__border-r-16___NayVO {
  border-radius: 16px !important;
}

.TeamSectionGroup-module__border-r-50___UFvDk {
  border-radius: 50% !important;
}

.TeamSectionGroup-module__primary-border___eRH_1 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TeamSectionGroup-module__primary-border-b___gN76t {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TeamSectionGroup-module__primary-border-t___US891 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TeamSectionGroup-module__primary-border-l___B3DA_ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TeamSectionGroup-module__primary-border-r___LWoGm {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TeamSectionGroup-module__secondary-border___mzIgz {
  border: 1px solid #637768;
}

.TeamSectionGroup-module__secondary-border-b___pnJCz {
  border-bottom: 1px solid #637768;
}

.TeamSectionGroup-module__secondary-border-t___tJlRF {
  border-top: 1px solid #637768;
}

.TeamSectionGroup-module__secondary-border-l___i3FBX {
  border-left: 1px solid #637768;
}

.TeamSectionGroup-module__secondary-border-r___tuQR0 {
  border-right: 1px solid #637768;
}

.TeamSectionGroup-module__gap-0___NF_qN {
  gap: 0 !important;
}

.TeamSectionGroup-module__gap-2___kh4Ew {
  gap: 2px !important;
}

.TeamSectionGroup-module__gap-4___vym56 {
  gap: 4px !important;
}

.TeamSectionGroup-module__gap-5___OJJ18 {
  gap: 5px !important;
}

.TeamSectionGroup-module__gap-6___Afahj {
  gap: 6px !important;
}

.TeamSectionGroup-module__gap-8___LMA_N {
  gap: 8px !important;
}

.TeamSectionGroup-module__gap-10___lh4mn {
  gap: 10px !important;
}

.TeamSectionGroup-module__gap-12___hozkd {
  gap: 12px !important;
}

.TeamSectionGroup-module__gap-14___y77q7 {
  gap: 14px !important;
}

.TeamSectionGroup-module__gap-16___tW7aQ {
  gap: 16px !important;
}

.TeamSectionGroup-module__gap-18___Yvtbe {
  gap: 18px !important;
}

.TeamSectionGroup-module__gap-20___Q3HO7 {
  gap: 20px !important;
}

.TeamSectionGroup-module__gap-24___YFqTf {
  gap: 24px !important;
}

.TeamSectionGroup-module__gap-26____m16F {
  gap: 26px !important;
}

.TeamSectionGroup-module__gap-30___oEXCJ {
  gap: 30px !important;
}

.TeamSectionGroup-module__gap-32___ebdMa {
  gap: 32px !important;
}

.TeamSectionGroup-module__gap-40___i8Dp2 {
  gap: 40px !important;
}

.TeamSectionGroup-module__gap-50___f4pEU {
  gap: 50px !important;
}

.TeamSectionGroup-module__flex-1___b9Huv {
  flex: 1;
}

.TeamSectionGroup-module__flex-none___bBb9G {
  flex: none !important;
}

.TeamSectionGroup-module__flex-column___sFfQN {
  display: flex;
  flex-direction: column !important;
}

.TeamSectionGroup-module__flex-row___lqVuy {
  display: flex;
  flex-direction: row !important;
}

.TeamSectionGroup-module__vertically-centered___WbHdz {
  display: flex;
  align-items: center !important;
}

.TeamSectionGroup-module__horizontally-centered___OnI_x {
  display: flex;
  justify-content: center !important;
}

.TeamSectionGroup-module__horizontally-end___vLBJI {
  display: flex;
  justify-content: end !important;
}

.TeamSectionGroup-module__vertically-start___wLp1w {
  display: flex;
  align-items: start !important;
}

.TeamSectionGroup-module__space-between___qDxJ5 {
  display: flex;
  justify-content: space-between !important;
}

.TeamSectionGroup-module__flex-wrap___Ra2ux {
  flex-wrap: wrap !important;
}

.TeamSectionGroup-module__height-100___JHF0Z {
  height: 100%;
}

.TeamSectionGroup-module__width-50___kP2pj {
  width: 50% !important;
}

.TeamSectionGroup-module__width-100___a9lgX {
  width: 100%;
}

.TeamSectionGroup-module__cursor-pointer___j2ibF {
  cursor: pointer;
}

.TeamSectionGroup-module__cursor-not-allowed___yywxf {
  cursor: not-allowed !important;
}

.TeamSectionGroup-module__absolute-centered___EFZTv {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TeamSectionGroup-module__absolute___wqoQZ {
  position: absolute;
}

.TeamSectionGroup-module__relative___Y9g__ {
  position: relative;
}

.TeamSectionGroup-module__fixed___QBI0F {
  position: fixed;
}

.TeamSectionGroup-module__visible___BIvAa {
  opacity: 1;
}

.TeamSectionGroup-module__invisible___vpx4p {
  opacity: 0;
}

.TeamSectionGroup-module__col-90___ia9cy {
  width: 90% !important;
}

.TeamSectionGroup-module__col-auto___hl0pn {
  width: auto !important;
}

.TeamSectionGroup-module__medical-tabs___Fn1rP {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TeamSectionGroup-module__medical-table-new___oHPje {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TeamSectionGroup-module__medical-table-new___oHPje:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TeamSectionGroup-module__medical-table-new___oHPje::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TeamSectionGroup-module__medical-table-new___oHPje::-webkit-scrollbar-track {
  display: none;
}
.TeamSectionGroup-module__medical-table-new___oHPje.TeamSectionGroup-module__no-pagination___Fg_X5 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TeamSectionGroup-module__medical-table-new___oHPje.TeamSectionGroup-module__no-pagination___Fg_X5:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TeamSectionGroup-module__medical-table-new___oHPje.TeamSectionGroup-module__no-pagination___Fg_X5::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TeamSectionGroup-module__medical-table-new___oHPje.TeamSectionGroup-module__no-pagination___Fg_X5::-webkit-scrollbar-track {
  display: none;
}

.TeamSectionGroup-module__medical-table-empty___VJnTm {
  padding: 14px 40px !important;
}

.TeamSectionGroup-module__icon-btn___guHlV {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TeamSectionGroup-module__search-icon___ccz9x {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TeamSectionGroup-module__disable-select____qxok {
  user-select: none;
}

.TeamSectionGroup-module__break-word___gZ9wp {
  word-break: break-word;
}

.TeamSectionGroup-module__popup-clear-btn___tXgcH {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TeamSectionGroup-module__scroll-m-b-20___fHAZ_ {
  scroll-margin-bottom: 20px;
}

.TeamSectionGroup-module__teamGroup___kSSbo {
  overflow: hidden;
  background: #ffffff;
}

.TeamSectionGroup-module__teamHeader___rk1Yj {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  background: #fafafa;
}

.TeamSectionGroup-module__teamHeaderDefault___pNOt0 {
  background: #f4f4f5;
}

.TeamSectionGroup-module__teamHeaderTrigger___U8BZp {
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  outline: none;
}
.TeamSectionGroup-module__teamHeaderTrigger___U8BZp:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.TeamSectionGroup-module__teamChevron___PQ6wh {
  flex-shrink: 0;
  color: #a1a1aa;
  transition: transform 0.15s ease;
}

.TeamSectionGroup-module__teamChevronCollapsed___KAmR_ {
  transform: rotate(-90deg);
}

.TeamSectionGroup-module__teamLabel___V7oPG {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TeamSectionGroup-module__defaultBadge___m3zeq {
  flex-shrink: 0;
  padding: 0 4px;
  border-radius: 4px;
  background: #e4e4e7;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  text-transform: uppercase;
  color: #3f3f46;
}

.TeamSectionGroup-module__teamRollup___zu9y4 {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  font-size: 13px;
}

.TeamSectionGroup-module__rollupOpen___akVgR {
  color: #71717a;
}

.TeamSectionGroup-module__rollupDot___BuWfr {
  color: #d4d4d8;
}

.TeamSectionGroup-module__rollupDone___EY0x7 {
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
  color: #166534;
}
.TeamSectionGroup-module__rollupDone___EY0x7 svg {
  align-self: center;
}

.TeamSectionGroup-module__pinTeamButton___SJNi4,
.TeamSectionGroup-module__copyTeamButton___UVJLk {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 1px;
  border: 0;
  border-radius: 3px;
  background: transparent;
  color: #a1a1aa;
  cursor: pointer;
  transition: color 0.15s;
  outline: none;
}
.TeamSectionGroup-module__pinTeamButton___SJNi4:focus-visible,
.TeamSectionGroup-module__copyTeamButton___UVJLk:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}
.TeamSectionGroup-module__pinTeamButton___SJNi4:hover,
.TeamSectionGroup-module__copyTeamButton___UVJLk:hover {
  color: #3f3f46;
}

.TeamSectionGroup-module__teamProgressTrack___hA8V1 {
  height: 3px;
  background: #f4f4f5;
}

.TeamSectionGroup-module__teamProgressFill___gFyZE {
  height: 100%;
  transition: width 0.4s ease-out;
}

.TeamSectionGroup-module__teamProgressDone___y_Ztj {
  background: #bbf7d0;
}

.TeamSectionGroup-module__teamProgressActive___QrzK3 {
  background: #fde68a;
}

.TeamSectionGroup-module__teamBody___biScO {
  overflow: hidden;
}

.TeamSectionGroup-module__completedSection___nacM3 {
  border-top: 1px solid #f4f4f5;
}

.TeamSectionGroup-module__completedToggle___tMaO4 {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border: 0;
  background: rgba(250, 250, 250, 0.6);
  color: #166534;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: background-color 0.15s;
}
.TeamSectionGroup-module__completedToggle___tMaO4:hover {
  background: #f4f4f5;
}

.TeamSectionGroup-module__completedChevron___MdeEz {
  flex-shrink: 0;
  transition: transform 0.15s ease;
}

.TeamSectionGroup-module__completedChevronCollapsed___RfPsr {
  transform: rotate(-90deg);
}

.TeamSectionGroup-module__completedRows____R16d {
  border-top: 1px solid #f4f4f5;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/ReadinessDetail/TeamSectionGroup.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,gBAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EEUA,aAAA;AFqpBF;AEnpBE;EACE,0BAAA;EACA,mBALuB;AF0pB3B;;AA/pBA;EACE,cAAA;EACA,cAAA;EACA,gCAAA;AAkqBF;;AA/pBA;EACE,yBAAA;AAkqBF;;AA/pBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAkqBF;;AA/pBA;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AAkqBF;;AA/pBA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;AAkqBF;;AA/pBA;EACE,cAAA;AAkqBF;;AA/pBA;EACE,cAAA;AAkqBF;;AA/pBA;EACE,oBAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;AAkqBF;AAhqBE;EACE,kBAAA;AAkqBJ;;AA9pBA;;EAEE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EE9DA,aAAA;AFguBF;AE9tBE;;EACE,0BAAA;EACA,mBALuB;AFsuB3B;AApqBE;;EACE,cAAA;AAuqBJ;;AAnqBA;EACE,WAAA;EACA,mBAAA;AAsqBF;;AAnqBA;EACE,YAAA;EACA,+BAAA;AAsqBF;;AAnqBA;EACE,mBAAA;AAsqBF;;AAnqBA;EACE,mBAAA;AAsqBF;;AAnqBA;EACE,gBAAA;AAsqBF;;AAnqBA;EACE,6BAAA;AAsqBF;;AAnqBA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,SAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;AAsqBF;AApqBE;EACE,mBAAA;AAsqBJ;;AAlqBA;EACE,cAAA;EACA,gCAAA;AAqqBF;;AAlqBA;EACE,yBAAA;AAqqBF;;AAlqBA;EACE,6BAAA;AAqqBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.teamGroup {\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.teamHeader {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 10px;\n  background: #fafafa;\n}\n\n.teamHeaderDefault {\n  background: #f4f4f5;\n}\n\n.teamHeaderTrigger {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  align-items: center;\n  gap: 8px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  @include focus-ring;\n}\n\n.teamChevron {\n  flex-shrink: 0;\n  color: #a1a1aa;\n  transition: transform 0.15s ease;\n}\n\n.teamChevronCollapsed {\n  transform: rotate(-90deg);\n}\n\n.teamLabel {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.defaultBadge {\n  flex-shrink: 0;\n  padding: 0 4px;\n  border-radius: 4px;\n  background: #e4e4e7;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 16px;\n  text-transform: uppercase;\n  color: #3f3f46;\n}\n\n.teamRollup {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 4px;\n  margin-left: auto;\n  font-size: 13px;\n}\n\n.rollupOpen {\n  color: #71717a;\n}\n\n.rollupDot {\n  color: #d4d4d8;\n}\n\n.rollupDone {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 2px;\n  color: #166534;\n\n  svg {\n    align-self: center;\n  }\n}\n\n.pinTeamButton,\n.copyTeamButton {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  padding: 1px;\n  border: 0;\n  border-radius: 3px;\n  background: transparent;\n  color: #a1a1aa;\n  cursor: pointer;\n  transition: color 0.15s;\n  @include focus-ring;\n\n  &:hover {\n    color: #3f3f46;\n  }\n}\n\n.teamProgressTrack {\n  height: 3px;\n  background: #f4f4f5;\n}\n\n.teamProgressFill {\n  height: 100%;\n  transition: width 0.4s ease-out;\n}\n\n.teamProgressDone {\n  background: #bbf7d0;\n}\n\n.teamProgressActive {\n  background: #fde68a;\n}\n\n.teamBody {\n  overflow: hidden;\n}\n\n.completedSection {\n  border-top: 1px solid #f4f4f5;\n}\n\n.completedToggle {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 10px;\n  border: 0;\n  background: rgba(250, 250, 250, 0.6);\n  color: #166534;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  transition: background-color 0.15s;\n\n  &:hover {\n    background: #f4f4f5;\n  }\n}\n\n.completedChevron {\n  flex-shrink: 0;\n  transition: transform 0.15s ease;\n}\n\n.completedChevronCollapsed {\n  transform: rotate(-90deg);\n}\n\n.completedRows {\n  border-top: 1px solid #f4f4f5;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TeamSectionGroup-module__font-s-10___awlbg`,
	"fontS12": `TeamSectionGroup-module__font-s-12___vtcaz`,
	"fontS13": `TeamSectionGroup-module__font-s-13___z5C5Q`,
	"fontS14": `TeamSectionGroup-module__font-s-14___v9G5s`,
	"fontS15": `TeamSectionGroup-module__font-s-15___gChI6`,
	"fontS16": `TeamSectionGroup-module__font-s-16___MuDm9`,
	"fontS18": `TeamSectionGroup-module__font-s-18___TmC7Z`,
	"fontS20": `TeamSectionGroup-module__font-s-20___uAAY4`,
	"fontS22": `TeamSectionGroup-module__font-s-22___Fc0YL`,
	"fontS28": `TeamSectionGroup-module__font-s-28___zXMIQ`,
	"fontW400": `TeamSectionGroup-module__font-w-400___JeWYE`,
	"fontW500": `TeamSectionGroup-module__font-w-500___HDCK8`,
	"fontW600": `TeamSectionGroup-module__font-w-600___Ue3lG`,
	"fontW700": `TeamSectionGroup-module__font-w-700___Sm4wa`,
	"p5": `TeamSectionGroup-module__p-5___Q8kpD`,
	"p12": `TeamSectionGroup-module__p-12___chIHN`,
	"p16": `TeamSectionGroup-module__p-16___pMOMi`,
	"p30": `TeamSectionGroup-module__p-30___XC0Yv`,
	"pB0": `TeamSectionGroup-module__p-b-0___h3AFE`,
	"pB5": `TeamSectionGroup-module__p-b-5___p9rpc`,
	"pB10": `TeamSectionGroup-module__p-b-10___cgr4D`,
	"pB12": `TeamSectionGroup-module__p-b-12___IqbAX`,
	"pB16": `TeamSectionGroup-module__p-b-16___bJN8D`,
	"pB18": `TeamSectionGroup-module__p-b-18___rkplP`,
	"pB20": `TeamSectionGroup-module__p-b-20___zdUoF`,
	"pB25": `TeamSectionGroup-module__p-b-25___gg6bU`,
	"pB30": `TeamSectionGroup-module__p-b-30___txiLP`,
	"pB50": `TeamSectionGroup-module__p-b-50___pA2VL`,
	"pT0": `TeamSectionGroup-module__p-t-0___hvUyX`,
	"pT12": `TeamSectionGroup-module__p-t-12___abmJo`,
	"pT16": `TeamSectionGroup-module__p-t-16___ALPB2`,
	"pT18": `TeamSectionGroup-module__p-t-18___Mm2aU`,
	"pT20": `TeamSectionGroup-module__p-t-20___TUV9R`,
	"pT30": `TeamSectionGroup-module__p-t-30___una2i`,
	"pT40": `TeamSectionGroup-module__p-t-40___p9lby`,
	"pT50": `TeamSectionGroup-module__p-t-50___CjKPM`,
	"pL20": `TeamSectionGroup-module__p-l-20___mXDLh`,
	"pL30": `TeamSectionGroup-module__p-l-30___KcOkb`,
	"pL40": `TeamSectionGroup-module__p-l-40___G2ULF`,
	"pR16": `TeamSectionGroup-module__p-r-16___qBm9e`,
	"pR20": `TeamSectionGroup-module__p-r-20___jx1fK`,
	"pR30": `TeamSectionGroup-module__p-r-30___sXIsn`,
	"pR50": `TeamSectionGroup-module__p-r-50___sZg6H`,
	"pR60": `TeamSectionGroup-module__p-r-60___RKSSF`,
	"mB1": `TeamSectionGroup-module__m-b-1___tIcLj`,
	"mB2": `TeamSectionGroup-module__m-b-2___rt5fs`,
	"mB6": `TeamSectionGroup-module__m-b-6___ZReZX`,
	"mB8": `TeamSectionGroup-module__m-b-8___DTSrk`,
	"mB10": `TeamSectionGroup-module__m-b-10___ytDTK`,
	"mB14": `TeamSectionGroup-module__m-b-14___Y52dN`,
	"mB16": `TeamSectionGroup-module__m-b-16___oIj69`,
	"mB20": `TeamSectionGroup-module__m-b-20___kE3Zb`,
	"mB22": `TeamSectionGroup-module__m-b-22___W6eWg`,
	"mB24": `TeamSectionGroup-module__m-b-24___qYd1Z`,
	"mB30": `TeamSectionGroup-module__m-b-30___H7lQl`,
	"mB32": `TeamSectionGroup-module__m-b-32___feMwa`,
	"mB40": `TeamSectionGroup-module__m-b-40___b88GJ`,
	"mT2": `TeamSectionGroup-module__m-t-2___vJeAE`,
	"mT3": `TeamSectionGroup-module__m-t-3___Cvy1u`,
	"mT4": `TeamSectionGroup-module__m-t-4___AjWTY`,
	"mT5": `TeamSectionGroup-module__m-t-5___wpZXB`,
	"mT8": `TeamSectionGroup-module__m-t-8___jQiS6`,
	"mT10": `TeamSectionGroup-module__m-t-10___DnFcS`,
	"mT15": `TeamSectionGroup-module__m-t-15___eF3TE`,
	"mT16": `TeamSectionGroup-module__m-t-16___IHlSq`,
	"mT20": `TeamSectionGroup-module__m-t-20___p0oS9`,
	"mT22": `TeamSectionGroup-module__m-t-22___dJig9`,
	"mT30": `TeamSectionGroup-module__m-t-30___noxxv`,
	"mT32": `TeamSectionGroup-module__m-t-32___ULgkS`,
	"mLAuto": `TeamSectionGroup-module__m-l-auto___vwONj`,
	"mL4": `TeamSectionGroup-module__m-l-4___NGRmL`,
	"mL5": `TeamSectionGroup-module__m-l-5___HkmlT`,
	"mL6": `TeamSectionGroup-module__m-l-6___BwMoL`,
	"mL8": `TeamSectionGroup-module__m-l-8___iC6Yq`,
	"mL10": `TeamSectionGroup-module__m-l-10___mRx7J`,
	"mL16": `TeamSectionGroup-module__m-l-16___UMAxM`,
	"mL20": `TeamSectionGroup-module__m-l-20___voRBk`,
	"mL24": `TeamSectionGroup-module__m-l-24___upLxv`,
	"mL30": `TeamSectionGroup-module__m-l-30___h1n3e`,
	"mL35": `TeamSectionGroup-module__m-l-35____jxt3`,
	"mL40": `TeamSectionGroup-module__m-l-40___DiLqg`,
	"mR8": `TeamSectionGroup-module__m-r-8___jPMnp`,
	"mR10": `TeamSectionGroup-module__m-r-10___Walm0`,
	"mR16": `TeamSectionGroup-module__m-r-16___u8AzH`,
	"mR20": `TeamSectionGroup-module__m-r-20___vL6oW`,
	"mR24": `TeamSectionGroup-module__m-r-24___sM0gT`,
	"mR30": `TeamSectionGroup-module__m-r-30___nDc8b`,
	"mR40": `TeamSectionGroup-module__m-r-40___hZdz2`,
	"borderR3": `TeamSectionGroup-module__border-r-3___nq9ui`,
	"borderR4": `TeamSectionGroup-module__border-r-4___EtqWT`,
	"borderR6": `TeamSectionGroup-module__border-r-6____pAyi`,
	"borderR10": `TeamSectionGroup-module__border-r-10___h75qZ`,
	"borderR12": `TeamSectionGroup-module__border-r-12___Zg4Nt`,
	"borderR16": `TeamSectionGroup-module__border-r-16___NayVO`,
	"borderR50": `TeamSectionGroup-module__border-r-50___UFvDk`,
	"primaryBorder": `TeamSectionGroup-module__primary-border___eRH_1`,
	"primaryBorderB": `TeamSectionGroup-module__primary-border-b___gN76t`,
	"primaryBorderT": `TeamSectionGroup-module__primary-border-t___US891`,
	"primaryBorderL": `TeamSectionGroup-module__primary-border-l___B3DA_`,
	"primaryBorderR": `TeamSectionGroup-module__primary-border-r___LWoGm`,
	"secondaryBorder": `TeamSectionGroup-module__secondary-border___mzIgz`,
	"secondaryBorderB": `TeamSectionGroup-module__secondary-border-b___pnJCz`,
	"secondaryBorderT": `TeamSectionGroup-module__secondary-border-t___tJlRF`,
	"secondaryBorderL": `TeamSectionGroup-module__secondary-border-l___i3FBX`,
	"secondaryBorderR": `TeamSectionGroup-module__secondary-border-r___tuQR0`,
	"gap0": `TeamSectionGroup-module__gap-0___NF_qN`,
	"gap2": `TeamSectionGroup-module__gap-2___kh4Ew`,
	"gap4": `TeamSectionGroup-module__gap-4___vym56`,
	"gap5": `TeamSectionGroup-module__gap-5___OJJ18`,
	"gap6": `TeamSectionGroup-module__gap-6___Afahj`,
	"gap8": `TeamSectionGroup-module__gap-8___LMA_N`,
	"gap10": `TeamSectionGroup-module__gap-10___lh4mn`,
	"gap12": `TeamSectionGroup-module__gap-12___hozkd`,
	"gap14": `TeamSectionGroup-module__gap-14___y77q7`,
	"gap16": `TeamSectionGroup-module__gap-16___tW7aQ`,
	"gap18": `TeamSectionGroup-module__gap-18___Yvtbe`,
	"gap20": `TeamSectionGroup-module__gap-20___Q3HO7`,
	"gap24": `TeamSectionGroup-module__gap-24___YFqTf`,
	"gap26": `TeamSectionGroup-module__gap-26____m16F`,
	"gap30": `TeamSectionGroup-module__gap-30___oEXCJ`,
	"gap32": `TeamSectionGroup-module__gap-32___ebdMa`,
	"gap40": `TeamSectionGroup-module__gap-40___i8Dp2`,
	"gap50": `TeamSectionGroup-module__gap-50___f4pEU`,
	"flex1": `TeamSectionGroup-module__flex-1___b9Huv`,
	"flexNone": `TeamSectionGroup-module__flex-none___bBb9G`,
	"flexColumn": `TeamSectionGroup-module__flex-column___sFfQN`,
	"flexRow": `TeamSectionGroup-module__flex-row___lqVuy`,
	"verticallyCentered": `TeamSectionGroup-module__vertically-centered___WbHdz`,
	"horizontallyCentered": `TeamSectionGroup-module__horizontally-centered___OnI_x`,
	"horizontallyEnd": `TeamSectionGroup-module__horizontally-end___vLBJI`,
	"verticallyStart": `TeamSectionGroup-module__vertically-start___wLp1w`,
	"spaceBetween": `TeamSectionGroup-module__space-between___qDxJ5`,
	"flexWrap": `TeamSectionGroup-module__flex-wrap___Ra2ux`,
	"height100": `TeamSectionGroup-module__height-100___JHF0Z`,
	"width50": `TeamSectionGroup-module__width-50___kP2pj`,
	"width100": `TeamSectionGroup-module__width-100___a9lgX`,
	"cursorPointer": `TeamSectionGroup-module__cursor-pointer___j2ibF`,
	"cursorNotAllowed": `TeamSectionGroup-module__cursor-not-allowed___yywxf`,
	"absoluteCentered": `TeamSectionGroup-module__absolute-centered___EFZTv`,
	"absolute": `TeamSectionGroup-module__absolute___wqoQZ`,
	"relative": `TeamSectionGroup-module__relative___Y9g__`,
	"fixed": `TeamSectionGroup-module__fixed___QBI0F`,
	"visible": `TeamSectionGroup-module__visible___BIvAa`,
	"invisible": `TeamSectionGroup-module__invisible___vpx4p`,
	"col90": `TeamSectionGroup-module__col-90___ia9cy`,
	"colAuto": `TeamSectionGroup-module__col-auto___hl0pn`,
	"medicalTabs": `TeamSectionGroup-module__medical-tabs___Fn1rP`,
	"medicalTableNew": `TeamSectionGroup-module__medical-table-new___oHPje`,
	"noPagination": `TeamSectionGroup-module__no-pagination___Fg_X5`,
	"medicalTableEmpty": `TeamSectionGroup-module__medical-table-empty___VJnTm`,
	"iconBtn": `TeamSectionGroup-module__icon-btn___guHlV`,
	"searchIcon": `TeamSectionGroup-module__search-icon___ccz9x`,
	"disableSelect": `TeamSectionGroup-module__disable-select____qxok`,
	"breakWord": `TeamSectionGroup-module__break-word___gZ9wp`,
	"popupClearBtn": `TeamSectionGroup-module__popup-clear-btn___tXgcH`,
	"scrollMB20": `TeamSectionGroup-module__scroll-m-b-20___fHAZ_`,
	"teamGroup": `TeamSectionGroup-module__teamGroup___kSSbo`,
	"teamHeader": `TeamSectionGroup-module__teamHeader___rk1Yj`,
	"teamHeaderDefault": `TeamSectionGroup-module__teamHeaderDefault___pNOt0`,
	"teamHeaderTrigger": `TeamSectionGroup-module__teamHeaderTrigger___U8BZp`,
	"teamChevron": `TeamSectionGroup-module__teamChevron___PQ6wh`,
	"teamChevronCollapsed": `TeamSectionGroup-module__teamChevronCollapsed___KAmR_`,
	"teamLabel": `TeamSectionGroup-module__teamLabel___V7oPG`,
	"defaultBadge": `TeamSectionGroup-module__defaultBadge___m3zeq`,
	"teamRollup": `TeamSectionGroup-module__teamRollup___zu9y4`,
	"rollupOpen": `TeamSectionGroup-module__rollupOpen___akVgR`,
	"rollupDot": `TeamSectionGroup-module__rollupDot___BuWfr`,
	"rollupDone": `TeamSectionGroup-module__rollupDone___EY0x7`,
	"pinTeamButton": `TeamSectionGroup-module__pinTeamButton___SJNi4`,
	"copyTeamButton": `TeamSectionGroup-module__copyTeamButton___UVJLk`,
	"teamProgressTrack": `TeamSectionGroup-module__teamProgressTrack___hA8V1`,
	"teamProgressFill": `TeamSectionGroup-module__teamProgressFill___gFyZE`,
	"teamProgressDone": `TeamSectionGroup-module__teamProgressDone___y_Ztj`,
	"teamProgressActive": `TeamSectionGroup-module__teamProgressActive___QrzK3`,
	"teamBody": `TeamSectionGroup-module__teamBody___biScO`,
	"completedSection": `TeamSectionGroup-module__completedSection___nacM3`,
	"completedToggle": `TeamSectionGroup-module__completedToggle___tMaO4`,
	"completedChevron": `TeamSectionGroup-module__completedChevron___MdeEz`,
	"completedChevronCollapsed": `TeamSectionGroup-module__completedChevronCollapsed___RfPsr`,
	"completedRows": `TeamSectionGroup-module__completedRows____R16d`
};
module.exports = ___CSS_LOADER_EXPORT___;
